
import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import uke from './img/UKE.jpg'
import xolida from './img/xolida.png'
import video from './Video/1video.mp4'


export const Muallif = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="card" >
            <Button className='button' onClick={showModal}>
                Mualliflar
            </Button>
            <Modal
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                className="custom-modal"
            >
                <br />
                    <img className='muallif muallif2' src={uke} alt="" /><br />
                <div className='muallif'>

                    <div>
                        <hr />
                        <h3 className='muallifbox2'>USMONOV KAMOLIDDIN ESHKULOVICH </h3>
                        <h4 className='muallifbox2'>TIQXMMI Milliy tadqiqot universitetining “Traktorlar va avtomobillar” kafedrasi dotsenti, texnika fanlari falsafa doktori, dotsent K.E. USMONOV 60 dan ortiq ilmiy maqolalar, jumladan 10 dan ortig‘i xorijiy jurnallarda, hamda 4 dan ortiq ixtiro va foydali modellarga olingan patentlarning va 5 ta EHM dasturining muallifi.
                            usmonov-74@inbox.ru</h4>
                        <hr />
                    </div>
                </div>

                <br />
                    <img className='muallif muallif2' src={xolida} alt="" />
                <div className='muallif'>

                    <div>
                        <br /><hr />

                        <h3 className='muallifbox2'>XASANOVA XOLIDA IBODULLAYEVNA</h3>
                        <h4 className='muallifbox2'>"Toshkent irrigatsiya va qishloq xoʻjaligini mexanizatsiyalash muhandislari instituti" Milliy tadqiqot universitetining “Traktorlar va avtomobillar” kafedrasi dotsenti, kimyo fanlari falsafa doktori. dotsent X.I.Xasanova 80 dan ortiq ilmiy maqolalar, jumladan 20 dan ortiq xorijiy jurnallardagi maqolalar muallifi
                            kholida_khasanova@yahoo.com
                        </h4>

                        <hr />
                    </div>
                </div>

            </Modal>
        </div>
    )
}
